import {t} from "@lingui/core/macro";
import {useState} from "react";

import Banner from "@khanacademy/wonder-blocks-banner";

import InlineMarkdown from "./inline-markdown.tsx";

export default function DisclaimerBanner(props: {text: string}) {
    const {text} = props;

    const [dismissed, setDismissed] = useState(false);

    if (dismissed) {
        return null;
    }

    return (
        <div data-remove-on-print>
            <Banner
                kind="info"
                layout="floating"
                text={<InlineMarkdown text={text} />}
                onDismiss={() => setDismissed(true)}
                aria-label={t`Disclaimer`}
                dismissAriaLabel={t`Dismiss disclaimer`}
            />
        </div>
    );
}
